import { Component, inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { first } from 'rxjs';
import { LoadSavedCartModalComponent } from '../../../../../components/load-saved-cart-modal/load-saved-cart-modal.component';
import { Cart } from '../../../../../models/cart';
import { CartService } from '../../../../../services/cart/cart.service';
import { CartsService } from '../../../../../services/carts/carts.service';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';

@Component({
  selector: 'lib-dynamic-page-dc-cart-list',
  standalone: false,
  templateUrl: './dynamic-page-dc-cart-list.component.html',
  styleUrl: './dynamic-page-dc-cart-list.component.scss'
})
export class DynamicPageDcCartListComponent extends DynamicPageDcBaseComponent implements OnInit {
  private cartsService = inject(CartsService);
  private cartService = inject(CartService);
  private ngbModal = inject(NgbModal);
  private gungNotificationService = inject(GungNotificationService);
  private translateService = inject(TranslateService);

  elementId = 'cart-list';
  fields = {
    title: 'Saved carts',
    listRoute: '/carts',
    listLinkText: 'See all carts',
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  };

  items: Cart[] = [];
  loading = true;

  get isQuotes(): boolean {
    return this.element?.id === 'quote-list';
  }

  override ngOnInit(): void {
    if (this.element?.id === 'quote-list') {
      this.fields = {
        ...this.fields,
        title: 'Saved quotes',
        listRoute: '/saved-quotes',
        listLinkText: 'See all quotes'
      };
    }
    super.ngOnInit();
    if (this.mode === 'renderer') {
      const source$ = this.isQuotes ? this.cartsService.getQuotes() : this.cartsService.getCarts();
      source$.pipe(first()).subscribe({
        next: items => {
          this.items = items.sort(
            (a, b) => new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()
          );
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      });
    }
  }

  navigateToList(): void {
    if (this.edit) return;
    this.router.navigate([this.element.fields.listRoute || this.fields.listRoute]);
  }

  loadItem(item: Cart): void {
    if (this.edit) return;
    const ref = this.ngbModal.open(LoadSavedCartModalComponent, { size: 'md' });
    ref.result.then(
      result => {
        if (!result) return;
        const rows = item.data.rows.map(row => ({
          productId: row.productId || row.id,
          targetStockId: row.targetStockId,
          productPartialId: row?.productPartialId ?? undefined,
          qty: row.qty || row.quantity,
          extra: row.extra
        }));
        if (result === 'replace') {
          this.cartService.clearCart();
        }
        this.cartService.bulkAddToCart(rows);
        this.cartService.bulkSetExtra(rows);
        const count = rows.length;
        const key = count > 1 ? 'PRODUCTS_ADDED_TO_CART' : 'PRODUCT_ADDED_TO_CART';
        const msg = this.translateService.instant(key, { quantity: count, value: item.name });
        this.gungNotificationService.notify('', msg, 'success');
      },
      () => {}
    );
  }
}
